<template>
  <div class="committee-renew-contract-page figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">
          <span class="child-tab-title is-muted" @click="goBack">{{ $t('committeeRenewContract.pageListTitle') }}</span>
          <span class="child-tab-separator">&gt;</span>
          <span class="child-tab-title is-active">{{ $t('committeeRenewContract.pageTitle') }}</span>
          <el-button size="small" class="figma-btn-back" @click="goBack">{{ $t('committeeRenewContract.action.back') }}</el-button>
        </div>
        <div class="figma-header-divider"></div>
      </div>

      <!-- 父合同信息 -->
      <div v-if="parentContract.contractId" class="figma-parent-card">
        <div class="parent-card-title">{{ $t('committeeRenewContract.parentInfo.title') }}</div>
        <div class="parent-info-row">
          <div class="parent-info-item">
            <span class="parent-info-label">{{ $t('committeeRenewContract.parentInfo.contractName') }}</span>
            <span class="parent-info-value">{{ parentContract.contractName || '-' }}</span>
          </div>
          <div class="parent-info-item">
            <span class="parent-info-label">{{ $t('committeeRenewContract.parentInfo.contractCode') }}</span>
            <span class="parent-info-value">{{ parentContract.contractCode || '-' }}</span>
          </div>
          <div class="parent-info-item">
            <span class="parent-info-label">{{ $t('committeeRenewContract.parentInfo.status') }}</span>
            <span class="parent-info-value">{{ parentContract.stateName || '-' }}</span>
          </div>
        </div>
      </div>

      <draft-contract-form
        ref="draftForm"
        class="renew-form-child"
        :community-list="communityList"
        :edit-data="renewData"
        @back="goBack"
        @success="handleSuccess"
      />
    </div>
  </div>
</template>

<script>
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import { queryContract } from '@/api/contract/expirationContractManageApi'
import DraftContractForm from './draftContractForm.vue'

export default {
  name: 'CommitteeRenewContractList',
  components: { DraftContractForm },
  data() {
    return {
      communityList: [],
      parentContract: {
        contractId: '',
        contractName: '',
        contractCode: '',
        stateName: ''
      },
      renewData: null
    }
  },
  created() {
    this.initPage()
  },
  methods: {
    async initPage() {
      await this.loadCommunities()
      this.loadParentContract()
    },
    async loadCommunities() {
      try {
        const res = await listCommunitysByOwnerCommittee({ page: 1, row: 1000 })
        this.communityList = res.data || []
      } catch (e) {
        this.communityList = []
      }
    },
    async loadParentContract() {
      const { contractId, contractCode, contractName, stateName } = this.$route.query
      if (!contractId) {
        this.$message.error(this.$t('committeeRenewContract.message.noContractId'))
        this.goBack()
        return
      }
      this.parentContract = { contractId, contractCode, contractName, stateName }
      // Set renew data for the form - prefill with parent contract info
      this.renewData = {
        contractParentId: contractId,
        parentContractCode: contractCode,
        parentContractName: contractName,
        parentStateName: stateName,
        contractName: contractName || '',
        contractCode: contractCode || '',
        // Other fields will be filled by user
        communityId: '',
        contractType: '',
        partyA: '',
        aContacts: '',
        aLink: '',
        partyB: '',
        bContacts: '',
        bLink: '',
        operator: '',
        operatorLink: '',
        amount: '',
        startTime: '',
        endTime: '',
        signingTime: '',
        contractFilePo: [],
        rooms: [],
        objType: '1111',
        objId: '-1',
        audit: '',
        contractTypeSpecs: []
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    handleSuccess() {
      this.$message.success(this.$t('committeeRenewContract.message.saveSuccess'))
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.committee-renew-contract-page {
  height: calc(100vh - 60px);
  background: #EBF2FA;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.figma-white-card {
  background: white;
  border-radius: 0 0 12px 12px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.figma-page-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 24px 12px;
  gap: 12px;
  flex-shrink: 0;
}
.figma-page-title {
  font-size: 16px;
  font-weight: 600;
  color: #1D2129;
  font-family: 'PingFang SC';
  line-height: 22px;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.child-tab-title { color: #1D2129; cursor: default; }
.child-tab-title.is-muted { color: #8C9BB4; cursor: pointer; }
.child-tab-title.is-active { color: #1D2129; cursor: default; }
.child-tab-separator { color: #8C9BB4; font-size: 16px; font-weight: 500; }
.figma-btn-back {
  margin-left: auto;
  width: 78px;
  height: 38px;
  min-height: 38px;
  padding: 0 !important;
  background: white !important;
  border: 1px solid #0E76FF !important;
  color: #0E76FF !important;
  border-radius: 10px !important;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.figma-btn-back:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; }

/* Parent Contract Info */
.figma-parent-card {
  margin: 0 24px 16px;
  padding: 16px 24px;
  background: #F8FBFF;
  border-radius: 12px;
  border: 1px solid #EBF2FA;
  flex-shrink: 0;
}
.parent-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #1D2129;
  margin-bottom: 12px;
  font-family: 'PingFang SC';
}
.parent-info-row {
  display: flex;
  gap: 24px;
}
.parent-info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.parent-info-label {
  font-size: 14px;
  color: #8C9BB4;
  font-family: 'PingFang SC';
  white-space: nowrap;
}
.parent-info-value {
  font-size: 14px;
  color: #1D2129;
  font-family: 'PingFang SC';
  font-weight: 500;
}

.renew-form-child {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
</style>
